export const AdminCoachPageDynamic = () => import('./components/AdminCoachPage');
